<!-- 最新任务 -->
<template>
  <div class="Aliststyle">
    <el-carousel trigger="click" :height="bannerHeight + 'px'" :interval="5000">
      <el-carousel-item v-for="(data, idd) in tableData" :key="idd">
        <div class="newlist">
          <div
            class="newlist_item"
            v-for="(item, index) in data"
            :key="index"
            @click="Tosignuplie(item)"
          >
            <!-- blue -->
            <img
              class="newlist_bage"
              width="109"
              height="4"
              :src="
                index % 2 == 0
                  ? require('../../assets/image/origin.png')
                  : require('../../assets/image/blue.png')
              "
              alt=""
            />
            <div class="newlist_head">
              <div
                class="newlist_biao"
                :style="'color:' + runtClolr(item.projectType)"
              >
                {{ item.projectTypeName }}
              </div>
              <div class="newlist_name">{{ item.packageName }}</div>
            </div>

            <div class="newlist_xu">
              <div class="newlist_xu_my">
                <span>项目名称：</span> {{ item.projectName }}
              </div>
              <div class="newlist_xu_my">
                <span>项目价格：</span> ￥{{ item.projectBudget.toFixed(2) }}
              </div>
              <div class="newlist_xu_my" style="font-size: 12px;">
                <span style="font-size: 14px;">报名时间：</span>
                {{ item.startTime }}至{{ item.endTime }}
              </div>
            </div>

            <div class="newlist_btn">
              <div class="newlist_btn_lfet">
                <span v-if="item.type === 0" :data-projectid="item.projectId"
                  >整包</span
                >
                <span v-if="item.type === 1" :data-projectid="item.projectId"
                  >建模包</span
                >
                <span v-if="item.type === 2" :data-projectid="item.projectId"
                  >需求包</span
                >
                <span v-if="item.type === 3" :data-projectid="item.projectId"
                  >UI设计包</span
                >
                <span v-if="item.type === 4" :data-projectid="item.projectId"
                  >运维包</span
                >
                <span v-if="item.type === 5" :data-projectid="item.projectId"
                  >实施包</span
                >
                <span class="newlist_btn_lfet_je"
                  >￥{{ item.packageMoney.toFixed(2) }}</span
                >
              </div>
              <img
                class="btn_img"
                :src="runtName(item.status)"
                width="80.85"
                height="65.15"
                alt=""
              />

              <!-- <el-button
                :style="
                  index % 2 == 0
                    ? 'background: #F2994A;border-color: #F2994A'
                    : 'background: #3B78FF;border-color: #3B78FF'
                "
                type="primary"
                class="alisbtn"
                round
                size="mini"
                >{{ runtName(item.status) }}</el-button
              > -->
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { showNumber, packageListHomepage } from "@/api/projectSquare/xmgc";
import { getDicts } from "@/api/dict/data";

export default {
  data() {
    return {
      proTypeClass: "gongys",
      bannerHeight: null, // 轮播高度
      // 最新发布(1),进行中(2)
      tabPosition: "1",
      // 假数据报名人数
      indehandata: ["2", "5", "6", "1", "2", "6", "12", "7", "4", "6"],
      // 首页列表
      tableData: [],
    };
  },
  created() {
    // 交易总数
    this.packHome();
  },
  mounted() {
    this.setSize(window.innerWidth);
    // 窗口大小发生改变
    window.onresize = ({ targert }) => this.setSize(targert.innerWidth);
  },
  methods: {
    setSize(width) {
      // 通过浏览器宽度(图片宽度)计算高度
      // this.bannerHeight = 860 / 1920 * width;
      this.bannerHeight = 1055;
    },
    numberSerzi(data) {
      if (data != null) {
        return data.toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, "$&,");
      } else {
        return;
      }
    },

    packHome() {
      packageListHomepage(this.tabPosition)
        .then(response => {
          let arrData = [];
          for (let i = 0; i < response.data.length; ) {
            arrData.push(response.data.slice(i, (i += 16)));
          }
          this.tableData = arrData;
        })
        .catch(response => {});
    },
    // 报名
    Tosignuplie(itmind) {
      if (itmind.projectId !== undefined) {
        this.$router.push("/Detailsonthesquare.html/" + itmind.projectId);
      }
    },
    // 返回字体颜色
    runtClolr(hyname) {
      const colorData = [
        { name: 1, color: "#F2994A" },
        { name: 2, color: "#33BC8B" },
        { name: 3, color: "#37CCF6" },
        { name: 4, color: "#F06B6B" },
        { name: 5, color: "#5797FF" },
        { name: 6, color: "#4A72FF" },
        { name: 7, color: "#5797FF" },
        { name: 8, color: "#FF9110" },
        { name: 9, color: "#ff9257" },
        { name: 10, color: "#1080ff" }
      ];
      let newData=colorData.find(obj => obj.name == hyname)
      if(newData){
        return newData.color
      }else{
        return "#F2994A"
      }
      // return colorData.find(obj => obj.name == hyname).color;
    },

    // 返回按钮名称
    runtName(status) {
      // 报名中     // 2.报名中 1.准备中
      // 已截止     // 14.已截止报名
      // 开发中     // 3.开发中 6.第一次不通过 7.第二次不通过 8.第三次不通过 11.待验收 12.部署中 13.部署失败 15.预部署成功
      // 已完成     // 9.不通过 4.待评价 5.已评价 10.未完成

      let btnName = "";
      // 1.准备中 2.报名中
      if (status == 1 || status == 2) {
        btnName = require("../../assets/image/indexqiye/zhaomuz.png");
      }
      // 14.已截止报名
      if (status == 14) {
        btnName = require("../../assets/image/indexqiye/yicb.png");
      }
      // 3.开发中 6.第一次不通过 7.第二次不通过 8.第三次不通过 11.待验收 12.部署中 13.部署失败 15.预部署成功
      if (
        status == 3 ||
        status == 6 ||
        status == 7 ||
        status == 8 ||
        status == 11 ||
        status == 12 ||
        status == 13 ||
        status == 15
      ) {
        btnName = require("../../assets/image/indexqiye/kafz.png");
      }
      // 9.不通过 4.待评价 5.已评价 10.未完成
      if (status == 9 || status == 4 || status == 5 || status == 10) {
        btnName = require("../../assets/image/indexqiye/yiwc.png");
      }

      return btnName;
    }
  }
};
</script>

<style scoped>
.Aliststyle {
  /* background: #F1F2F4; */
  width: 1300px;
  margin: 0 auto;
}

.newlist {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
}

.newlist_item {
  width: 288px;
  background: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(0, 38, 60, 0.1);
  border-radius: 4px 4px 4px 4px;
  text-align: left;
  position: relative;
  padding: 16px 0px 0px 0px;
  box-sizing: border-box;
  margin-top: 24px;
  cursor: pointer;
  transition: all 1s;
}

.newlist_item:hover {
  /* transform: scale(1.08); */
  transform: translateY(-10px);
  z-index: 3;
  box-shadow: 0px 2px 20px 0px #999999;
}

.newlist_item .newlist_bage {
  position: absolute;
  left: 0;
  top: 0;
}

.newlist_item .newlist_head {
  font-size: 16px;
  font-weight: 800;
  line-height: 19px;
  padding: 0 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f1f2f4;
}
.newlist_item .newlist_biao {
  font-size: 12px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: bold;
  color: #33bc8b;
  line-height: 14px;
  text-align: right;
}

.newlist_item .newlist_name {
  font-size: 20px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.9);
  line-height: 23px;
  display: -webkit-box !important;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.newlist_xu {
  padding: 0 20px;
  padding-top: 8px;
  padding-bottom: 17px;
}
.newlist_xu_my {
  font-size: 14px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.7);
  line-height: 16px;
  margin-top: 9px;
}
.newlist_xu_my span {
  color: rgba(0, 0, 0, 0.5);
}

.newlist_xu_mn {
  font-size: 16px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.7);
  line-height: 19px;
}

.newlist_time {
  width: fit-content;
  font-size: 14px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.5);
  line-height: 16px;
  border-radius: 17px 17px 17px 17px;
  border: 1px solid #d9d9d9;
  padding: 2px 8px;
  margin: 16px 0;
}

.newlist_btn {
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8fafb;
  border-radius: 0px 0px 4px 4px;
  padding: 0 20px;
  padding-bottom: 5px;
  box-sizing: border-box;
  position: relative;
}
.newlist_btn .btn_img {
  position: absolute;
  right: 20px;
  bottom: 5px;
}

.newlist_btn .newlist_btn_lfet {
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.9);
  line-height: 16px;
}

.newlist_btn .newlist_btn_lfet .newlist_btn_lfet_je {
  font-size: 20px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 800;
  color: #eb5757;
  line-height: 23px;
}

.alisbtn {
  /* width: 88px; */
  height: 34px;
  border-radius: 31px 31px 31px 31px;
  font-size: 14px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  color: #f2f2f2;
  line-height: 16px;
}

/deep/ .el-carousel__button {
  background-color: #897e7e;
  opacity: 1;
  width: 10px;
  height: 10px;
  border-radius: 10px;
}

/deep/ .el-carousel__indicator.is-active button {
  background-color: #f9b600;
  width: 25px;
  transition: 1s;
}
</style>



// WEBPACK FOOTER //
// src/components/Lunbot/Thelistofdata.vue